import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

function Loading(props) {
  const { classes } = props;
  return (
    <div className={classes.circularProgress}>
        <Typography align="center" className={classes.load} variant="h6">Loading</Typography>
      <CircularProgress  size={60} thickness={3} color="primary" />
    </div>
  );
}

const styles = {
  circularProgress: {
    position: 'fixed',
    top: 'calc(50% - 45px)',
    left: 'calc(50% - 45px)',
  },
  load:{
      marginBottom:20,
  }
};
export default (withStyles(styles)(Loading));
